const day = new Intl.DateTimeFormat("en-GB", { day: "2-digit", month: "short", year: "numeric" });

export const formatDay = (iso) => day.format(new Date(iso));
